import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from "react-i18next"
import { Tooltip } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TablePagination from "@mui/material/TablePagination";
import { t } from 'i18next'
import dayjs from 'dayjs'
import { useState } from 'react'
import { visuallyHidden } from '@mui/utils';
import { getComparator, stableSort } from '../../helpers/DailyBoardTableHelpers'
import { toLower, xor } from 'lodash'
import clsx from 'clsx'

function Row(props) {
    const { row, user } = props;
    const [open, setOpen] = React.useState(false)

    return (
        <React.Fragment >
            <TableRow sx={{ '& > *': { borderBottom: 'unset !important' } }}>
                <TableCell sx={{ padding: '8px 16px', position: 'relative' }}>
                    <Tooltip disableInteractive title={t(row?.type)}>
                        <div
                            className={clsx("absolute top-0 left-0 border-[7.5px] border-solid cursor-pointer border-r-transparent border-b-transparent", {
                                "border-t-[#336195] border-l-[#336195]": row?.type === 'shipment',
                                "border-t-[#b7472a] border-l-[#b7472a]": row?.type === 'collection'
                            })}
                        ></div>
                    </Tooltip>
                    {row?.customer_name}
                </TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    {row?.vendor_name}
                </TableCell>
                <TableCell sx={{ padding: '8px 16px', fontWeight: '500' }}>{row.sales_order.so_number}</TableCell>
                <TableCell sx={{ padding: '8px 16px', fontWeight: '500' }}>{row.purchase_order.po_number}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.sales_order.requested_delivery_date} />}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    {
                        <Status status_key={row.bt_status} />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 5px' }}>
                    {
                        <TodaysSalesOrderAction user={user} row={row} />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell style={{ padding: 0 }} colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '20%' }}>{t('item_no')}</TableCell>
                                        <TableCell sx={{ width: '50%' }}>{t('description')}</TableCell>
                                        {row?.type == 'collection' ? (
                                            <>
                                                <TableCell sx={{ width: '10%' }}>{t('qty_expected')}</TableCell>
                                                <TableCell sx={{ width: '10%' }}>{t('qty_loaded')}</TableCell>
                                                <TableCell sx={{ width: '10%' }}>{t('qty_received')}</TableCell>
                                            </>
                                        ) : (
                                            <>
                                                <TableCell sx={{ width: '10%' }}>{t('quantity_ordered')}</TableCell>
                                                <TableCell sx={{ width: '10%' }}>{t('quantity_shipped')}</TableCell>
                                                <TableCell sx={{ width: '10%' }}>{t('qty_delivered')}</TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row?.type == 'collection' ? (
                                        <>
                                            {row.purchase_order.items.map((historyRow) => (
                                                <TableRow key={`poi-${historyRow.id}`}>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow.item_no}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow.description}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_ordered}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow?.qty_to_receive}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow?.qty_received}</TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                    ) : (
                                        <>
                                            {row.sales_order.items.map((historyRow) => (
                                                <TableRow key={`soi-${historyRow.id}`}>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow.item_no}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow.description}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_ordered}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow?.qty_to_ship}</TableCell>
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow?.qty_shipped}</TableCell>
                                                </TableRow>
                                            ))}
                                        </>
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </React.Fragment>
    );
}

const SortableTableHeaderRow = (props) => {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {/* Customer Name cell */}
                <TableCell
                    sortDirection={orderBy === 'customer_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'customer_name'}
                        direction={orderBy === 'customer_name' ? order : 'asc'}
                        onClick={createSortHandler('customer_name')}>
                        {t('customer')}
                        {orderBy === 'customer_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                <TableCell
                    sortDirection={orderBy === 'vendor_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'vendor_name'}
                        direction={orderBy === 'vendor_name' ? order : 'asc'}
                        onClick={createSortHandler('vendor_name')}>
                        {t('supplier')}
                        {orderBy === 'vendor_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {!localStorage.getItem('client_id').includes('pallet-book') && (
                    <>
                        {/* Sales Order No. cell */}
                        <TableCell
                            sortDirection={orderBy === 'so_number' ? order : false}>
                            <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                                active={orderBy === 'so_number'}
                                direction={orderBy === 'so_number' ? order : 'asc'}
                                onClick={createSortHandler('so_number')}>
                                {t('sales_order_no')}
                                {orderBy === 'so_number' ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                        {/* Purchase Order No. cell */}
                        <TableCell
                            sortDirection={orderBy === 'po_number' ? order : false}>
                            <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                                active={orderBy === 'po_number'}
                                direction={orderBy === 'po_number' ? order : 'asc'}
                                onClick={createSortHandler('po_number')}>
                                {t('purchase_order_no')}
                                {orderBy === 'po_number' ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    </>
                )}
                {/* Requested Delivery Date cell */}
                <TableCell
                    sortDirection={orderBy === 'requested_delivery_date' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'requested_delivery_date'}
                        direction={orderBy === 'requested_delivery_date' ? order : 'asc'}
                        onClick={createSortHandler('requested_delivery_date')}>
                        {t('requested_delivery_date')}
                        {orderBy === 'requested_delivery_date' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Status cell */}
                <TableCell
                    sortDirection={orderBy === 'bt_status_id' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'bt_status_id'}
                        direction={orderBy === 'bt_status_id' ? order : 'asc'}
                        onClick={createSortHandler('bt_status_id')}>
                        {t('status')}
                        {orderBy === 'bt_status_id' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: '#88909C !important', fontWeight: '400' }}>{t('actions')}</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>
    )
}

export default function CollapsibleTable({ items, total, user, page = 1, rowsPerPage = 10, opc = undefined, orppc = undefined, osc = undefined, defaultSortOrder = 'desc' }) {

    const pg = Number(page - 1)
    const rpg = Number(rowsPerPage)
    const [orderBy, setOrderBy] = useState('requested_delivery_date')
    const [order, setOrder] = useState(defaultSortOrder)

    function handleChangePage(event, newpage) {
        if(opc) {
            opc(Number(newpage + 1));
        }
    }

    function handleChangeRowsPerPage(event) {
        if(orppc) {
            opc(1);
            orppc(parseInt(event.target.value, 10));
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
        if(osc) {
            osc(`${property},${isAsc ? 'desc' : 'asc'}`)
        }
    }

    return (
        <>

            <div style={{ width: '100%', mb: 2, border: 'none' }}>
                <TableContainer>
                    <Table aria-label="collapsible table" stickyHeader>
                        {!localStorage.getItem('client_id').includes('pallet-book') ? (
                            <colgroup>
                                <col width="15%" />
                                <col width="15%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="10%" />
                                <col />
                            </colgroup>
                        ) : (
                                <colgroup>
                                    <col width="30%" />
                                    <col width="30%" />
                                    <col width="25%" />
                                    <col width="10%" />
                                    <col />
                                </colgroup>
                        )}
                        <SortableTableHeaderRow
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {items.length <= 0 && (
                                <TableRow>
                                    <TableCell
                                        colSpan={8}
                                        sx={{ textAlign: 'center' }}
                                    >
                                            {t('no_data')}
                                    </TableCell>
                                </TableRow>
                            )}
                            {items?.map((row) => (
                                <Row key={row.id} row={row} user={user} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className='table-pagination'
                    labelRowsPerPage={t('rowsPerPage')}
                    rowsPerPageOptions={[10, 15]}
                    component="div"
                    count={total}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </>
    );
}

const Status = ({ status_key }) => {

    const getStatusColorStylings = () => {
        switch(toLower(status_key)) {
            case "open":
            case "reopened":
                return "bg-[#D2ECFE] text-[#0073C1]"
            case "released":
                return "bg-[#FFD48F] text-[#9D6000]"
            case "assigned_to_driver":
                return "bg-[#FFE4B9] text-[#804E00]"
            case "in_transit":
                return "bg-[#D5EDFB] text-[#008A93]"
            case "shipped":
                return "bg-[#019738] text-[#ffffff]"
            case "completed":
                return "bg-[#BEFFD6] text-[#017C40]"
            case "invoiced":
                return "bg-[#E7F7EF] text-[#0CAF60]"
            default:
                return "bg-[#FFF0F0] text-[#FD6A6A]"
        }
    }

    return (
        <div className={"w-full rounded-md p-1 text-center font-[500] capitalize " + getStatusColorStylings()}>{t(status_key)}</div>
    )
}

const TodaysSalesOrderAction = ({user, row}) => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const { id, bt_status_id: status, sales_order, purchase_order, uploaded_bol, type } = row
    const uploaded_driver_bol = row?.type === 'shipment'
        ? sales_order?.uploaded_driver_bol
        : purchase_order?.uploaded_driver_bol

    const getPodUrl = (
        stream = 'view',
        party = 'customer'
    ) => {
        if(uploaded_driver_bol)
            return uploaded_driver_bol?.document_url

        if(uploaded_bol)
            return uploaded_bol.document_url

        const urlStem = `broker-transactions/${id}`
        const urlRoot = `${process.env.REACT_APP_BACKEND_URL}/api`
        const urlLeaves = `proof-of-delivery?stream=${stream}&party=${party}&CLIENT_ID=${localStorage.getItem('client_id')}&CLIENT_TIMEZONE=${encodeURIComponent(localStorage.getItem('client_timezone'))}`

        return `${urlRoot}/${urlStem}/${urlLeaves}`
    }

    const userHasPermissions = (targets = []) => {
        return user?.permissions.some((permission) => targets.includes(permission.name))
    }

    return (
        <>
            <div className='flex gap-1'>
                <Tooltip disableInteractive title="BOL/POD" placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <a href={getPodUrl('view', type == 'shipment' ? 'customer' : 'supplier')} target="_blank"><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-print"></i></span></a>
                    </div>
                </Tooltip>

                {
                    (
                        (
                            ['master_admin', 'office_manager'].includes(user?.role)
                            || userHasPermissions(['daily-board-update'])
                        )
                        && (
                            status === 1
                            || status === 3
                        )
                    ) ? (
                        <Tooltip disableInteractive title={t('update')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(`${id}`, { state: { prevPathname: location.pathname } })}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-pencil"></i></span></button>
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip disableInteractive title={t('open')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(`${id}`, { state: { prevPathname: location.pathname } })}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-eye"></i></span></button>
                            </div>
                        </Tooltip>
                    )
                }

            </div>
        </>
    )
}

export const ShowDate = ({ date }) => {

    const date1 = new Date(dayjs(date).format("YYYY-MM-DD"))
    const date2 = new Date(dayjs().format("YYYY-MM-DD"))

    return (
        <div>
            {
                date1 < date2 ? <p style={{ color: '#F00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                    date1 == date2 ? <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                        date1 > date2 ? <p style={{ color: '#008E00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                            <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p>
            }
        </div>
    )
}
